function invertDate(date: string): string {
  const values = date.split('/');

  return `${values[1]}/${values[0]}/${values[2]}`;
}

export default invertDate;
